import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import LoadingOverlay from "../UI/LoadingOverlay/LoadingOverlay";

export default function RoleBasedRoute({
  children,
  allowedRoles = [],
  redirectTo = "/access-denied?reason=insufficient_permissions",
}) {
  const { isAuthenticated, loading, user, isUserInactive, isNavigating } =
    useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/auth", { replace: true });
    } else if (!loading && isAuthenticated && isUserInactive) {
      navigate("/access-denied?reason=account_disabled", { replace: true });
    } else if (!loading && isAuthenticated && !isUserInactive && user) {
      if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
        navigate(redirectTo, { replace: true });
      }
    }
  }, [
    isAuthenticated,
    loading,
    isUserInactive,
    user,
    allowedRoles,
    navigate,
    redirectTo,
  ]);

  if (loading || isNavigating) {
    return (
      <LoadingOverlay
        isVisible={true}
        message={loading ? "Checking authentication..." : "Loading page..."}
        maxDisplayTime={loading ? 1000 : 300}
      />
    );
  }

  if (!isAuthenticated || isUserInactive) {
    return (
      <LoadingOverlay
        isVisible={true}
        message={
          !isAuthenticated
            ? "Redirecting to login..."
            : "Redirecting to access denied..."
        }
        maxDisplayTime={500}
      />
    );
  }

  if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.role)) {
    return (
      <LoadingOverlay
        isVisible={true}
        message="Redirecting to access denied..."
        maxDisplayTime={500}
      />
    );
  }

  return children;
}
